import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const MarkEmailRead = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf18c'}</MuiIcon>
    );
}
